import http from "../http-common";

export default class UserService{
    static signup(data){
        return http.post("/user/signup", data);
    }

    static login(data){
        return http.post("/user/login", data);
    }

}